module.exports = __webpack_public_path__ + "static/media/HIWPayConnect.5f09d828.svg";